(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/game-analyzes/map-draw-analyzes.js') >= 0) return;  svs.modules.push('/components/sport/game-analyzes/map-draw-analyzes.js'); "use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

let mapAnalysis;
let buildRow;
let getProductClassName;
if (svs.isServer) {
  mapAnalysis = require('./map-analysis.es6');
  buildRow = require('./build-row.es6');
  getProductClassName = require('trinidad-core').core.components.require('utils', 'products').getProductClassName;
} else {
  mapAnalysis = svs.sport.gameAnalyzes.mapAnalysis;
  buildRow = svs.sport.gameAnalyzes.buildRow;
  getProductClassName = svs.utils.products.getProductClassName;
}
const mapDrawAnalyzes = gameAnalyzes => gameAnalyzes.map(gameAnalysis => {
  const gameAnalyses = (gameAnalysis.gameAnalyses || []).map(mapAnalysis);
  const additionalData = {};
  gameAnalysis.properties.cnt_gameSystems.forEach(s => {
    additionalData[s] = buildRow(gameAnalyses, s);
  });
  if (gameAnalysis && gameAnalysis.gameinfo) {
    if (Array.isArray(gameAnalysis.gameinfo.products) && gameAnalysis.gameinfo.products.length !== 0) {
      additionalData.productName = getProductClassName(gameAnalysis.gameinfo.products[0]);
      additionalData.productId = gameAnalysis.gameinfo.products[0];
    }
    if (Array.isArray(gameAnalysis.gameinfo['sport-draws']) && gameAnalysis.gameinfo['sport-draws'].length !== 0) {
      additionalData.drawNumber = gameAnalysis.gameinfo['sport-draws'][0];
    }
  }
  return _objectSpread(_objectSpread({}, gameAnalysis), {}, {
    gameAnalyses
  }, additionalData);
});
if (typeof module !== 'undefined' && module.exports) {
  module.exports = mapDrawAnalyzes;
} else {
  setGlobal('svs.sport.gameAnalyzes.mapDrawAnalyzes', mapDrawAnalyzes);
}
 })(window);